// 1. React and Core Libraries
// STOMP protocol client for WebSocket
import _, { get, isEmpty } from "lodash"; // Utility functions
import React, { useEffect, useRef, useState } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap"; // UI tooltips
import { useDispatch, useSelector } from "react-redux"; // Redux state management
import { Outlet, useLocation, useNavigate } from "react-router-dom"; // Routing hooks/components
// WebSocket library (fallback support)
import Cookies from "universal-cookie"; // Cookie management

// 2. Static Assets (Images and Icons)
// Icon for back arrow (React Icons)
import { Glogo, logout, notification, user } from "../../assets/images/index"; // Image assets

// 3. Redux Slices (State Management)
// Common/global slice
import {
  removeProfilePic,
  resetLoggedUser,
  saveProfilePic,
  setLoggedUser,
  setPageLoading,
  setSessionExtend,
  setsessionToken,
} from "../commonSlice";

// Home module slice
import {
  resetHomeData,
  updateSelectedApp,
} from "../../Modules/Home/HomeSlice.js";

// Specific slice from Regulatory Compliance feature
import { setClickAble } from "../../Modules/governance-and-compliance/RegulatoryCompliance/circular9/slices/Circular9Slice.js";

// 4. Utilities / Helpers / Constants
import GetProxy from "../../app/GetProxy"; // API proxy setup or service handler
import { routes } from "../routes"; // Route definitions/constants
import { DDAllHide } from "../utilities/helpers.js"; // General helper functions
import { storageRemove } from "./Storage"; // LocalStorage/sessionStorage utility

// 5. Custom Components
import ProfileUploaderContent from "../../ProfileUploaderContent.jsx"; // Profile picture uploader UI
import WebSocketHandler from "../WebSocketHandler.js"; // WebSocket management handler
import AlertBox from "./Alert.jsx"; // Custom alert box component
import BreadCrumb from "./BreadCrumb"; // Breadcrumb navigation component
import CustomModal from "./CustomModal.jsx"; // Reusable modal component
// 6. Styles
import { FaAngleDoubleLeft, FaAngleDoubleRight } from "react-icons/fa";
import "./custom-components.style.scss"; // Custom SCSS styles for components

let client;
const proxy = GetProxy();
const Container = () => {
  const cookies = new Cookies();
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [tabClick, setTabClick] = useState({});
  const [lastTabAccess, setLastTabAccess] = useState(false);
  const [lastFocusByMouse, setLastFocusByMouse] = useState(false);
  const [activeSubItem, setActiveSubItem] = useState("");
  const [sidebarExpanded, setSidebarExpanded] = useState("");
  const [expandedSubItems, setExpandedSubItems] = useState({});
  const [manualCollapse, setManualCollapse] = useState(false);
  const [activeItem, setActiveItem] = useState("");
  const [hasClicked, setHasClicked] = useState(false);

  //Profile Pic Uploader State
  const [showUploader, setShowUploader] = useState(false);
  const [profileAlert, setProfileAlert] = useState({
    show: false,
    type: "danger",
    message: "",
  });
  const [alert, setAlert] = useState({
    show: false,
    message: "* File size shouldn’t exceed 150KB.",
    type: "info",
  });
  const [selectedFile, setSelectedFile] = useState(null);
  const [isImageRemoved, setIsImageRemoved] = useState(false);
  const [hasFileChanged, setHasFileChanged] = useState(false);

  const { userName, decodedUsername, userRole, usersProfilePic } = useSelector(
    (state) => state.common.loggedUser
  );
  const { isSaveProfilePicLoading } = useSelector((state) => state.common);

  const { openAlert, alertType, alertMessage } = useSelector(
    (state) => state.common.commonAlert
  );

  const pathName =
    get(location, "pathname", "") === "/gnc/ciso-view/Vulnerability" &&
      !userRole.includes("Ciso")
      ? ""
      : get(location, "pathname", "");
  const encoded = decodedUsername;

  const onNavigate = (e, url) => {
    e.preventDefault();
    dispatch(setClickAble(null));
    navigate(url);
  };

  const logOut = (e) => {
    e.preventDefault();
    var newURL =
      pathName === "/gnc/ciso-view/Vulnerability"
        ? "ITcompliance/VulnerabilityManagement"
        : pathName;
    sessionStorage.setItem("lastVisitedURL", newURL);
    sessionStorage.setItem("lastVistedURL", newURL);
    sessionStorage.setItem("isLoggedin", false);
    const Apitoken = cookies.get("apitoken");
    const User = cookies.get("username");
    dispatch(setSessionExtend(false));
    fetch("/auth?logout", {
      method: "GET",
      headers: {
        "DTOP-API-TOKEN": Apitoken,
        USERNAME: User,
      },
      redirect: "manual",
    })
      .then(() => {
        handleLogout();
        dispatch(resetLoggedUser());
        dispatch(resetHomeData());
        dispatch(setsessionToken(false));
        DDAllHide();
      })
      .catch((err) => {
        console.error(err);
      });
  };

  const handleLogout = () => {
    cookies.remove("jwttoken", { path: "/" });
    cookies.remove("Refersh", { path: "/" });
    cookies.remove("apitoken", { path: "/" });
    cookies.remove("username", { path: "/" });
    cookies.remove("decodedUsername", { path: "/" });
    cookies.remove("referstoken", { path: "/" });
    dispatch(setLoggedUser({ userName: "", decodedUsername: "", userRole: "", token: "" }));
    dispatch(setPageLoading(true));
    dispatch(setsessionToken(false));
    navigate("/auth");
  };

  const handleArrowNavigation = (event) => {
    const submenuOpen = document.querySelector(".nav.small");
    if (submenuOpen) {
      const submenuLinks = submenuOpen.querySelectorAll('[tabIndex="0"]');
      const currentLinkIndex = Array.from(submenuLinks).indexOf(
        document.activeElement
      );
      if (event.key === "ArrowUp") {
        event.preventDefault();
        const nextLinkIndex =
          currentLinkIndex === 0
            ? submenuLinks.length - 1
            : currentLinkIndex - 1;
        submenuLinks[nextLinkIndex].focus();
      } else if (event.key === "ArrowDown") {
        event.preventDefault();
        const nextLinkIndex = (currentLinkIndex + 1) % submenuLinks.length;
        submenuLinks[nextLinkIndex].focus();
      }
    }
  };

  const handleDocumentEvent = (event) => {
    if (event.type === "click") {
      setLastFocusByMouse(true);
      setLastTabAccess(false);
    } else if (event.type === "keydown" && event.key === "Tab") {
      setLastFocusByMouse(false);
      setLastTabAccess(true);
    }
  };

  const handleFocusIn = (input, lastFocusByMouse, lastTabAccess) => {
    // Remove classes from all inputs
    document
      .querySelectorAll("input, textarea, button,select")
      .forEach((el) => {
        el.classList.remove("tabClickStyle", "mouseClickStyle");
      });

    // Add class to the current input
    if (lastFocusByMouse) {
      input.classList.add("mouseClickStyle");
    } else if (lastTabAccess) {
      input.classList.add("tabClickStyle");
    }
  };

  const handleFocusOut = (input) => {
    // Remove classes from the input
    input.classList.remove("tabClickStyle", "mouseClickStyle");
  };

  useEffect(() => {
    if (!isEmpty(tabClick)) {
      document.addEventListener("keydown", handleArrowNavigation);
      return () => {
        document.removeEventListener("keydown", handleArrowNavigation);
      };
    }
  }, [tabClick]);

  useEffect(() => {
    document.addEventListener("click", handleDocumentEvent);
    document.addEventListener("keydown", handleDocumentEvent);

    return () => {
      document.removeEventListener("click", handleDocumentEvent);
      document.removeEventListener("keydown", handleDocumentEvent);
    };
  }, []);

  useEffect(() => {
    const focusInHandler = (event) =>
      handleFocusIn(event.target, lastFocusByMouse, lastTabAccess);
    const focusOutHandler = (event) => handleFocusOut(event.target);

    document
      .querySelectorAll("input, textarea, button, select")
      .forEach((input) => {
        input.addEventListener("focusin", focusInHandler);
        input.addEventListener("focusout", focusOutHandler);
        input.addEventListener("mousemove", focusOutHandler);
      });

    return () => {
      document
        .querySelectorAll("input, textarea, button, select")
        .forEach((input) => {
          input.removeEventListener("focusin", focusInHandler);
          input.removeEventListener("focusout", focusOutHandler);
          input.addEventListener("mousemove", focusOutHandler);
        });
    };
  }, [lastFocusByMouse]);

  /// websock
  // useEffect(() => {
  //   client = new Client({
  //     brokerURL: `${proxy}/cmdb/websocket`,

  //     webSocketFactory: () => new SockJS(`${proxy}/cmdb/websocket`),

  //     onConnect: () => {
  //       client.subscribe("/topic/user", (message) => {
  //         const messageData = JSON.parse(message.body); // Parse the JSON data
  //         cookies.set("ProjectStatusUpdate", messageData, { path: "/" });
  //         dispatch(setProjectStatusUpdate({ scanStatus: messageData }));
  //       });
  //     },

  //     onStompError: (frame) => {
  //       console.error("WebSocket error:", frame);
  //     },
  //   });
  //   client.activate();

  //   return () => {
  //     client.deactivate(); // Cleanup on unmount
  //   };
  // }, [proxy]);

  const headerwrapRef = useRef(null);
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);
  const [screenHeight, setScreenHeight] = useState(window.innerHeight);
  const [pagetoggle, setpagetoggle] = useState(false);
  useEffect(() => {
    const handleResize = () => {
      setScreenWidth(window.innerWidth);
      setScreenHeight(window.innerHeight);
    };

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  const toggleSubSub = (label) => {
    setExpandedSubItems((prev) => ({
      ...prev,
      [label]: !prev[label],
    }));
  };
  // Check if a route has children that are visible in the sidebar
  const hasVisibleSidebarChildren = (route) => {
    return route.childNavs?.some((child) => !child.isNotSideBarNavigation);
  };

  const handleRouteClick = (e, route) => {
    setHasClicked(true);
    setActiveItem(route.name);

    // Handle navigation: if route allows navigation, navigate to first child or own path
    if (route.navigationDisable !== true) {
      let navigatePath = null;

      if (route.childNavs?.length) {
        navigatePath = route.childNavs[0].path;
      } else if (route.path) {
        navigatePath = route.path;
      }

      if (navigatePath) {
        onNavigate(e, navigatePath);
      }
    }

    // Only expand sidebar if route has visible sidebar children (not all isNotSideBarNavigation)
    if (hasVisibleSidebarChildren(route)) {
      if (activeItem === route.name) {
        setSidebarExpanded(false);
        setActiveItem(null);
      } else {
        setSidebarExpanded(true);
      }
    } else {
      // No visible children — collapse sidebar expansion
      setSidebarExpanded(false);
    }
  };
  const handleSubItemClick = (e, sub, route) => {
    e.preventDefault();
    setActiveSubItem(sub.name);
    setActiveItem(route.name);
    if (!sub.navigationDisable) {
      onNavigate(e, sub?.path);
      storageRemove();
      dispatch(updateSelectedApp({}));
    }
  };
  const handleChildNavClick = (e, route, child) => {
    e.preventDefault();
    setActiveItem(route.name);
    setActiveSubItem(child.name);

    if (child.navigationDisable && child.childNavs?.length > 0) {
      toggleSubSub(child.name);
    } else if (!child.navigationDisable) {
      onNavigate(e, child.path);
      storageRemove();
      dispatch(updateSelectedApp({}));
    }
  };
  const handleSubNavClick = (e, route, sub) => {
    setActiveSubItem(sub.name);
    setActiveItem(route.name);

    if (!sub.navigationDisable) {
      onNavigate(e, sub.path);
      storageRemove();
      dispatch(updateSelectedApp({}));
    }
  };
  useEffect(() => {
    setHasClicked(false);
  }, [pathName]);
  useEffect(() => {
    // When sidebar collapses, clear all expanded sub-items
    if (!pagetoggle) {
      setExpandedSubItems({});
      return;
    }

    // Don't override user's click intent (e.g. clicking Configuration icon while on Home page)
    if (hasClicked) {
      return;
    }

    // When sidebar is open, derive expanded items from current path (merge to preserve manual expansions)
    const segments = pathName.split("/").filter(Boolean);
    if (segments.length === 0) {
      return;
    }

    let foundSubItem = false;

    for (const route of routes) {
      if (
        !route.isNotSideBarNavigation &&
        route.path === segments[0]
      ) {
        setActiveItem(route.name);

        for (const child of route.childNavs || []) {
          if (!child.isNotSideBarNavigation) {
            // Check if this child itself matches the active path
            if (
              child.path &&
              (pathName === `/${child.path}` ||
                pathName.startsWith(`/${child.path}/`))
            ) {
              setActiveSubItem(child.name);
              foundSubItem = true;
              if (child.childNavs?.length) {
                setExpandedSubItems((prev) => ({
                  ...prev,
                  [child.name]: true,
                }));
              }
            }

            // Check if any of child's sub-items matches the active path
            // (handles children with no path, e.g. CMDB, and paths of any depth)
            for (const sub of child.childNavs || []) {
              if (
                !sub.isNotSideBarNavigation &&
                sub.path &&
                (pathName === `/${sub.path}` ||
                  pathName.startsWith(`/${sub.path}/`))
              ) {
                setActiveSubItem(sub.name);
                foundSubItem = true;
                setExpandedSubItems((prev) => ({
                  ...prev,
                  [child.name]: true,
                }));
              }
            }
          }
        }

        // Reset activeSubItem if no child/sub-item matches the current path
        if (!foundSubItem) {
          setActiveSubItem("");
        }

        break;
      }
    }
  }, [pathName, routes, pagetoggle]);

  // Auto-scroll sidebar when a nav item expands so children stay visible
  useEffect(() => {
    if (!pagetoggle || !activeItem) return;

    // Delay must exceed the sidebar CSS transition (0.28s) + child render buffer
    const timer = setTimeout(() => {
      const scrollContainer = headerwrapRef.current;
      if (!scrollContainer) return;

      const activeLi = scrollContainer.querySelector(`li[data-route-name="${activeItem}"]`);
      if (!activeLi) return;

      const liTop = activeLi.offsetTop;
      const liBottom = liTop + activeLi.offsetHeight;
      const visibleTop = scrollContainer.scrollTop;
      const visibleBottom = visibleTop + scrollContainer.clientHeight;

      // Scroll down if children extend below visible area
      if (liBottom > visibleBottom) {
        scrollContainer.scrollTo({
          top: liBottom - scrollContainer.clientHeight + 24,
          behavior: "smooth",
        });
        // Scroll up if the item is above the visible area
      } else if (liTop < visibleTop) {
        scrollContainer.scrollTo({
          top: Math.max(0, liTop - 12),
          behavior: "smooth",
        });
      }
    }, 400);

    return () => clearTimeout(timer);
  }, [activeItem, pagetoggle, expandedSubItems]);

  const onProfileClick = () => {
    setShowUploader(true);
    setIsImageRemoved(false);
    setHasFileChanged(false);
    setSelectedFile(null);
  };

  const handleFileChange = (file) => {
    if (!file.type.startsWith("image/")) {
      return setAlert({
        show: true,
        message: "Only image files are allowed.",
        type: "danger",
      });
    }
    if (file.size > 150 * 1024) {
      return setAlert({
        show: true,
        message: "* File size shouldn’t exceed 150KB.",
        type: "danger",
      });
    }

    setSelectedFile(file);
    setAlert({ show: false, message: "", type: "" });
    setHasFileChanged(true);
    setIsImageRemoved(false);
  };

  function cropToCircle(imageBase64, size = 200) {
    return new Promise((resolve) => {
      const image = new Image();
      image.onload = () => {
        const canvas = document.createElement("canvas");
        canvas.width = size;
        canvas.height = size;
        const ctx = canvas.getContext("2d");

        // Draw a circular clip path
        ctx.beginPath();
        ctx.arc(size / 2, size / 2, size / 2, 0, Math.PI * 2, true);
        ctx.closePath();
        ctx.clip();

        // Draw the image within the clip
        ctx.drawImage(image, 0, 0, size, size);

        // Export as PNG with transparent corners
        resolve(canvas.toDataURL("image/png"));
      };
      image.src = imageBase64;
    });
  }

  const handleProfilePictureSave = (file) => {
    const decryptedUserName = decodedUsername;

    dispatch(
      saveProfilePic({
        file: file,
        payload: { userName: decryptedUserName },
      })
    )
      .unwrap()
      .then((res) => {
        setProfileAlert({
          show: true,
          type: res?.statusCodeValue == 200 ? "success" : "error",
          message: res.body || "something went wrong",
        });
        setShowUploader(false); // Close modal

        // Auto-dismiss alert after 3 seconds
        setTimeout(() => {
          setProfileAlert((prev) => ({ ...prev, show: false }));
        }, 3000);
      })
      .catch((err) => {
        setProfileAlert({
          show: true,
          type: err?.statusCodeValue == 200 ? "success" : "error",
          message: err?.body || "something went wrong",
        });

        setTimeout(() => {
          setProfileAlert((prev) => ({ ...prev, show: false }));
        }, 3000);
      });
  };

  const handleSave = (croppedImageBase64) => {
    const decryptedUserName = decodedUsername;

    // Case 1: Remove profile pic
    if (isImageRemoved && !selectedFile) {
      dispatch(
        removeProfilePic({
          payload: { userName: decryptedUserName },
        })
      )
        .unwrap()
        .then((res) => {
          setProfileAlert({
            show: true,
            type: res?.statusCodeValue === 200 ? "success" : "error",
            message: res?.body || "Something went wrong",
          });

          if (res?.statusCodeValue === 200) {
            setShowUploader(false);
          }

          setTimeout(() => {
            setProfileAlert((prev) => ({ ...prev, show: false }));
          }, 3000);
        })
        .catch((err) => {
          setProfileAlert({
            show: true,
            type: "error",
            message: err?.body || "Failed to remove profile picture.",
          });

          setTimeout(() => {
            setProfileAlert((prev) => ({ ...prev, show: false }));
          }, 3000);
        });

      return;
    }

    // Case 2: User selected and cropped a new file
    if (croppedImageBase64) {
      cropToCircle(croppedImageBase64).then((circularImageBase64) => {
        fetch(circularImageBase64)
          .then((res) => res.blob())
          .then((blob) => {
            const file = new File([blob], "profile.png", { type: "image/png" });
            handleProfilePictureSave(file);
          });
      });

      return;
    }

    // Case 3: No action
    setAlert({
      show: true,
      message: "Please select an image or click remove.",
      type: "info",
    });
  };

  const getPreviewImage = () => {
    // 1. If user selected a new file, show its preview
    if (selectedFile) {
      return URL.createObjectURL(selectedFile);
    }

    // 2. If user removed the image, show default
    if (isImageRemoved) {
      return user; // default image import
    }

    // 3. If user has existing profile pic, show it
    if (usersProfilePic) {
      return `data:image/jpeg;base64,${usersProfilePic}`;
    }

    // 4. Fallback to default image
    return user;
  };

  const onRemove = () => {
    setIsImageRemoved(true);
    setSelectedFile(null); // Clear any selected file
    setHasFileChanged(true);
    setAlert({ show: false, message: "", type: "" }); // Clear any previous alerts
  };

  const userRoleShow = () => {
    if (userRole && userRole.length !== 0) {
      const userRoleShow = userRole.map((item) =>
        item === "Ciso"
          ? "CISO"
          : item === "Department_head"
            ? "Department Head"
            : item === '"Division_head'
              ? "Division Head"
              : item === "Application_manager"
                ? "Application Manager"
                : item
      );
      if (userRoleShow) {
        return (
          <>
            <a className="">{userRoleShow[0]}</a>
          </>
        );
      }
    }
    return null; // Return null if no userRole exists or it's empty
  };

  return (
    <div className="wrapper_jr">
      <header
        className={`sidebar-header ${pagetoggle ? "expanded" : "collapsed"}`}
      // onMouseLeave={() => {
      //   setTabClick({});
      //   if (!hasClicked) {
      //     setpagetoggle(false);
      //     setManualCollapse(false);
      //   } else if (pagetoggle === false) {
      //     setHasClicked(false);
      //   }
      // }}
      >
        <div className="headerwrap m-auto" ref={headerwrapRef}>
          <div className="userwrap">
            <div className="header-logo">
              <div tabIndex={-1}>
                <img src={Glogo} alt="DevOpsLab-code8-deploy" />
              </div>
            </div>
            {pagetoggle && (
              <div className="search-container">
                <div className="headexora">
                  <h6>G360</h6>
                </div>
              </div>
            )}
            {/* {pagetoggle && (
              <div>
                {" "}
                <button
                  onClick={() => {
                    setpagetoggle(false);
                    setManualCollapse(true);
                  }}
                  style={{
                    background: "none",
                    border: "none",
                    color: "white",
                    fontSize: "16px",
                    cursor: "pointer",
                    marginLeft: "120px",
                    marginTop: "9px",
                  }}
                  aria-label="Collapse Sidebar"
                >
                  <FaAngleLeft />
                </button>
              </div>
            )} */}
          </div>
          <div className="nav small navSmall">
            <ul>
              {routes
                .filter((route) => !route.isNotSideBarNavigation)
                .map((route, index) => (
                  <li
                    className={`nav-items ${pathName.split("/")[1] === route?.path?.split("/")[0]
                      ? "active"
                      : ""
                      } ${tabClick.index === index ? "tabInde" : ""}`}
                    style={{
                      ...(pathName.split("/")[1] ===
                        route?.path?.split("/")[0] &&
                        (pagetoggle === false
                          ? { backgroundColor: "rgb(53, 70, 113)" }
                          : { border: "1px solid rgb(53, 70, 113)" })),
                    }}
                    key={route.path}
                    data-route-name={route.name}
                  >
                    <a
                      className={`nav-items ${activeItem === route.name ? "active" : ""
                        } ${!route.navigationDisable ? "navigable" : "non-navigable"
                        }`}
                      href={route.childNavs?.length ? `/${route.childNavs[0].path}` : route.path ? `/${route.path}` : undefined}
                      target="_blank"
                      rel="noopener noreferrer"
                      tabIndex={0}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        overflow: "hidden",
                        gap: "8px",
                        whiteSpace: "nowrap",
                      }}
                      onClick={(e) => {
                        // Only handle left click (not middle/right)
                        if (e.button === 0 && !e.ctrlKey && !e.metaKey) {
                          e.preventDefault();
                          const targetPath = route.childNavs?.length
                            ? route.childNavs[0].path
                            : route.path;
                          if (
                            pathName === `/${targetPath}` &&
                            route?.navigationDisable !== true
                          ) {
                            return; // Do nothing if already on this exact page
                          }
                          handleRouteClick(e, route);
                        }
                      }}
                    >
                      {(route.icon || route.reactIcon) && (
                        <div
                          onClick={(e) => {
                            e.stopPropagation();
                            e.preventDefault();
                            const hasVisibleChildren = hasVisibleSidebarChildren(route);
                            const isAlreadyActive =
                              pathName.split("/")[1] === route?.path?.split("/")[0];

                            // Routes without visible sidebar children: navigate directly, don't expand
                            if (!hasVisibleChildren) {
                              setHasClicked(true);
                              setActiveItem(route.name);
                              setActiveSubItem("");
                              if (route.navigationDisable !== true) {
                                const targetPath = route.childNavs?.length
                                  ? route.childNavs[0].path
                                  : route.path;
                                if (targetPath) {
                                  onNavigate(e, targetPath);
                                }
                              }
                              return;
                            }

                            // If sidebar is collapsed and this route is already active,
                            // just reopen the sidebar and let path-based useEffect restore state
                            if (!pagetoggle && isAlreadyActive) {
                              setHasClicked(false);
                              setpagetoggle(true);
                              setSidebarExpanded(true);
                              return;
                            }

                            setHasClicked(true);
                            setActiveItem(route.name);
                            setActiveSubItem("");

                            // Navigate if the route has a path
                            if (route.navigationDisable !== true) {
                              const targetPath = route.childNavs?.length
                                ? route.childNavs[0].path
                                : route.path;
                              if (targetPath) {
                                onNavigate(e, targetPath);
                              }
                            }

                            // Expand sidebar for routes with visible children
                            setpagetoggle(true);
                            setSidebarExpanded(true);
                          }}
                        >
                          {pagetoggle ? (
                            route.reactIcon ? (
                              <span className="nav-items-icon nav-items-react-icon">{route.reactIcon}</span>
                            ) : (
                              <img
                                src={route.icon}
                                alt={`${route.name} Icon`}
                                className="nav-items-icon"
                              />
                            )
                          ) : (
                            <OverlayTrigger
                              placement="right"
                              overlay={
                                <Tooltip className="custom-tooltip-home">
                                  {route.name}
                                </Tooltip>
                              }
                            >
                              {route.reactIcon ? (
                                <span className="nav-items-icon nav-items-react-icon">{route.reactIcon}</span>
                              ) : (
                                <img
                                  src={route.icon}
                                  alt={`${route.name} Icon`}
                                  className="nav-items-icon"
                                />
                              )}
                            </OverlayTrigger>
                          )}
                        </div>
                      )}

                      {pagetoggle && (
                        <div
                          style={{
                            overflowX: "auto",
                            whiteSpace: "nowrap",
                            msOverflowStyle: "none",
                            scrollbarWidth: "none",
                            maxWidth: "180px",
                            color: "white",
                          }}
                          className="nav-item-text"
                        >
                          {route.name}
                        </div>
                      )}
                    </a>

                    {pagetoggle &&
                      activeItem === route.name &&
                      hasVisibleSidebarChildren(route) && (
                        <div className="connected-timeline">
                          {route.childNavs
                            .filter((child) => {
                              if (child.isNotSideBarNavigation) {
                                return false;
                              }

                              if (
                                child.name === "Ciso Insights" &&
                                !userRole.includes("Ciso") &&
                                !userRole.includes("Operation")
                              ) {
                                return false;
                              }

                              return true;
                            })
                            .map((child, idx, arr) => {
                              const isFirst = idx === 0;
                              const isLast = idx === arr.length - 1;
                              return (
                                <React.Fragment key={child.name}>
                                  <div className="timeline-node" tabIndex={0}>
                                    <div className="timeline-connector">
                                      {!isFirst && (
                                        <div className="timeline-line-above"></div>
                                      )}
                                      <div
                                        className={`timeline-dot ${child?.path && typeof pathName === "string" &&
                                          (pathName === `/${child.path}` || pathName.startsWith(`/${child.path}/`))
                                          ? "active"
                                          : ""
                                          }`}
                                        onClick={() => {
                                          setActiveSubItem(child.name);
                                          toggleSubSub(child.name);
                                        }}
                                      ></div>
                                      {!isLast && (
                                        <div className="timeline-line-below"></div>
                                      )}
                                    </div>

                                    <div
                                      className={`timeline-heading ${activeSubItem === child.name
                                        ? "active"
                                        : ""
                                        }`}
                                    >
                                      {/* Clicking the text navigates */}
                                      <a
                                        href={
                                          child.childNavs?.length
                                            ? `/${child.childNavs[0].path}`
                                            : child.path
                                              ? `/${child.path}`
                                              : undefined
                                        }
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        style={{
                                          color: "inherit",
                                          textDecoration: "none",
                                          cursor: "pointer",
                                          flex: 1,
                                        }}
                                        onClick={(e) => {
                                          if (
                                            e.button === 0 &&
                                            !e.ctrlKey &&
                                            !e.metaKey
                                          ) {
                                            e.preventDefault();
                                            handleChildNavClick(
                                              e,
                                              route,
                                              child
                                            );
                                          }
                                        }}
                                      >
                                        {child.text}
                                      </a>
                                    </div>

                                    {/* Arrow toggles sub-nav - moved to the end */}
                                  </div>

                                  {/* Sub-child timeline */}
                                  {pagetoggle &&
                                    expandedSubItems[child.name] &&
                                    child.navigationDisable === true &&
                                    child.childNavs?.length > 0 && (
                                      <div className="sub-timeline">
                                        {child.childNavs
                                          .filter(
                                            (sub) => !sub.isNotSideBarNavigation
                                          )
                                          .map((sub, subIdx) => (
                                            <div
                                              key={sub.name}
                                              className="sub-timeline-node"
                                              tabIndex={0}
                                              onClick={(e) =>
                                                handleSubItemClick(
                                                  e,
                                                  sub,
                                                  route
                                                )
                                              }
                                            >
                                              <div className="sub-timeline-connector">
                                                <div className="sub-timeline-line-above"></div>
                                                <div
                                                  className={`sub-timeline-dot ${sub?.path && typeof pathName === "string" && (
                                                    pathName === `/${sub.path}` ||
                                                    pathName.startsWith(`/${sub.path}/`) ||
                                                    activeSubItem === sub?.name
                                                  )
                                                    ? "active"
                                                    : ""
                                                    }`}
                                                  onClick={(e) =>
                                                    handleSubNavClick(
                                                      e,
                                                      route,
                                                      sub
                                                    )
                                                  }
                                                ></div>
                                                {subIdx <
                                                  child.childNavs.length -
                                                  1 && (
                                                    <div className="sub-timeline-line-below"></div>
                                                  )}
                                              </div>
                                              <a
                                                href={
                                                  sub.path
                                                    ? `/${sub.path}`
                                                    : undefined
                                                }
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className={`sub-timeline-content ${activeSubItem === sub.name
                                                  ? "active"
                                                  : ""
                                                  }`}
                                                style={{
                                                  textDecoration: "none",
                                                  color: "white",
                                                  cursor: "pointer",
                                                }}
                                                onClick={(e) => {
                                                  if (
                                                    e.button === 0 &&
                                                    !e.ctrlKey &&
                                                    !e.metaKey
                                                  ) {
                                                    e.preventDefault();
                                                    handleSubItemClick(
                                                      e,
                                                      sub,
                                                      route
                                                    );
                                                  }
                                                }}
                                              >
                                                {sub.text}
                                              </a>
                                            </div>
                                          ))}
                                      </div>
                                    )}
                                </React.Fragment>
                              );
                            })}
                        </div>
                      )}
                  </li>
                ))}
            </ul>
          </div>
        </div>

        <div
          className={pagetoggle ? "pageToggleExpanded" : "pageToggleCollapsed"}
        >
          <div className="toggle-area">
            <button
              onClick={() => {
                const willOpen = !pagetoggle;
                setpagetoggle(willOpen);
                setManualCollapse(true);
                // When reopening, reset hasClicked so the path-based useEffect
                // can re-derive activeItem / expandedSubItems from the current route
                if (willOpen) {
                  setHasClicked(false);
                }
              }}
              className="toggle-icon"
              aria-label="Toggle Sidebar"
              tabIndex={0}
            >
              {pagetoggle ? <FaAngleDoubleLeft /> : <FaAngleDoubleRight />}
            </button>
          </div>
        </div>
      </header>

      <div className={pagetoggle ? "toggle-main" : "mainwrap content"}>
        <div className="topwrap">
          <div className="top_Header">
            <div className="topheader">
              <div className="topheader-left">
                {/* <h3 id="topheader_text">
                    {getPageTitle(pathName, routes)}
                    </h3> */}
                {pathName !== "/access-denied" && (
                  <BreadCrumb path={pathName} />
                )}
              </div>
              <div className="topheader-right">
                <div className="notify-block">
                  <a>
                    <img src={notification} />
                  </a>
                </div>
                <div className="userwrap">
                  <div className="logindes">
                    <h4 className={encoded === "sysadmin" ? "encoded" : ""}>
                      <a className="">{_.capitalize(encoded)}</a>
                    </h4>
                    <h6>{encoded !== "sysadmin" ? userRoleShow() : null}</h6>
                  </div>
                  <div className="loginico" onClick={onProfileClick}>
                    <a>
                      <img
                        src={`data:image/jpeg;base64,${usersProfilePic || ""}`}
                        alt="User Profile"
                        onError={(e) => {
                          e.target.onerror = null; // prevent infinite loop
                          e.target.src = user;
                        }}
                        style={{
                          width: "40px", // or your preferred size
                          height: "40px",
                          objectFit: "cover",
                          borderRadius: "50%",
                        }}
                      />
                    </a>
                  </div>
                </div>
                <div className="logout">
                  <OverlayTrigger
                    placement="bottom"
                    overlay={<Tooltip id="logout-tooltip">Logout</Tooltip>}
                  >
                    <a onClick={(e) => logOut(e)} style={{ cursor: "pointer" }}>
                      <img src={logout} alt="Logout" />
                    </a>
                  </OverlayTrigger>
                </div>
              </div>
            </div>
          </div>

          <div
            className="wrapper"
            style={pathName === "/access-denied" ? { padding: 0 } : {}}
          >
            <div key={location.key} className="page-content-wrapper">
              <Outlet />
            </div>
          </div>
        </div>
      </div>
      <AlertBox alert={openAlert} type={alertType} message={alertMessage} />
      <CustomModal
        modalOpen={showUploader}
        modalHide={() => setShowUploader(false)}
        closeBtn={true}
        closeBtnFuc={() => {
          setShowUploader(false);
          setAlert({
            show: false,
            message: "* File size shouldn’t exceed 150KB.",
            type: "",
          });
        }}
        modalBody={() => (
          <ProfileUploaderContent
            preview={getPreviewImage()}
            alert={alert}
            onFileChange={handleFileChange}
            onSave={handleSave}
            onRemove={onRemove}
            isLoading={isSaveProfilePicLoading}
            hasFileChanged={hasFileChanged}
            usersProfilePic={usersProfilePic}
            selectedFile={selectedFile}
            isImageRemoved={isImageRemoved}
          />
        )}
        modalCustomClass="profile-upload-modal"
        size="md"
        Modalsize="custom-modal-size"
      />
      <AlertBox
        alert={profileAlert.show}
        type={profileAlert.type}
        message={profileAlert.message}
      />
      <WebSocketHandler onLogout={handleLogout} />
    </div>
  );
};

export default Container;
